<template>
  <div class="profile header-item">
    <b-dropdown position="is-bottom-left" :mobile-modal="false">
      <a class="avatar" slot="trigger">
        <img :src="userThumb"
             alt="User">
      </a>
      <b-dropdown-item custom paddingless>
        <div class="profile-content">
          <span class="has-text-grey">{{ account.employee.organization__name | shortText(len=100) }}</span>
          <div class="name">{{account.employee.initials}}</div>
          <a @click="employeeDetail">{{ $t('interface.myProfile') }}</a>
          <a @click="employeeEdit">{{ $t('interface.profileSettings') }}</a>
          <a @click="changePassword">{{ $t('interface.changePassword') }}</a>
          <a href="//ijro.xtv.uz/learning/" target="_blank">{{ $t('interface.downloadInstruction') }}</a>
          <a @click="logout">{{ $t('interface.exit') }}</a>
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import defaultUserThumb from '../assets/user.svg'
  import {INCTRUCTION_URL} from '@/localSettings'

  export default {
    methods: {
      goTo(route) {
        this.$router.push({name: route})
      },
      logout() {
        this.$auth.unbind()
        this.$store.commit('Account/LOGOUT')
        this.goTo('login')
      },
      employeeDetail() {
        this.$router.push({name: 'employeeDetail', params: {employeeId: this.account.employee.id}})
      },
      employeeEdit() {
        this.$router.push({name: 'editEmployeeData', params: {employeeId: this.account.employee.id}})
      },
      changePassword() {
        this.$router.push({name: 'changePassword'})
      },
      downloadInstruction() {
        document.location.href = INCTRUCTION_URL
      },
    },
    computed: {
      ...mapState('Account', ['account']),
      userThumb() {
        return this.account.employee.thumb !== null ? this.account.employee.thumb : defaultUserThumb
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/variables";

  .profile {
    padding: 0 28px;

    .avatar {
      display: block;
      height: $header-height;
      padding: 13px 0;

      img {
        border: 1px solid #C5CDD2;
        box-sizing: border-box;
        position: relative;
        top: 2px;
        height: 40px;
        width: 40px;
        border-radius: 50%;
      }
    }

    .profile-content {
      padding: 28px 40px 10px 40px;
      width: 290px;

      .name {
        color: #3498db;
        border-bottom: 1px solid $border-color;
        font-size: 16px;
        padding-bottom: 12px;
        margin-bottom: 18px;
      }

      a {
        display: block;
        margin-bottom: 20px;
      }
    }
  }
</style>
